import { render, staticRenderFns } from "./EdJsonEditor.vue?vue&type=template&id=38eb10ad&scoped=true&"
import script from "./EdJsonEditor.vue?vue&type=script&lang=js&"
export * from "./EdJsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./EdJsonEditor.vue?vue&type=style&index=0&id=38eb10ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eb10ad",
  null
  
)

export default component.exports